import React from 'react';
import { Header } from './components/Header';
import { FeaturedCaseStudy } from './components/FeaturedCaseStudy';
import { StatsSection } from './components/StatsSection';
import { LogoCarousel } from './components/LogoCarousel';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex min-h-screen w-full flex-col bg-black" data-id="element-0" data-mp="3f8exlfkofls3">
      <Header data-id="element-1" data-mp="2rlp1euv0elfe" />
      <main className="flex-1" data-id="element-2" data-mp="2rl6v15emuqtr">
        <LogoCarousel data-id="element-3" data-mp="2mluawsf5bxuv" />
        <FeaturedCaseStudy data-id="element-4" data-mp="2mmlt91jqfz37" />
        <StatsSection data-id="element-5" data-mp="2mndq0fp2g2v2" />
        <FinalCta data-id="element-6" data-mp="2mjpwvhnj9igv" />
      </main>
      <Footer data-id="element-7" data-mp="31agput0v2nlk" />
    </div>;
}